import styled from 'styled-components';

export const ResultsCountWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  /* padding-top: 24px; */
`;
